// navigation.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private isTopLevelPage = new BehaviorSubject<boolean>(true);
  private topLevelRoutes: string[] = [
    '/t/home',
    '/t/tab2',
    '/t/jobs',
    '/t/invoices',
    '/t/quotes',
    '/t/contacts',
    '/t/products',
  ];

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Check if the current route is one of the top-level routes
        const isTopLevel = this.topLevelRoutes.includes(event.urlAfterRedirects.split('?')[0]);
        this.isTopLevelPage.next(isTopLevel);
      }
    });
  }

  public getIsTopLevelPage() {
    return this.isTopLevelPage.asObservable();
  }
}
